import React, {Component} from "react";
import {Divider, Grid, IconButton, Stack, Tooltip} from "@mui/material";
import Typography from "@mui/material/Typography";
import {connect} from "react-redux";
import {getKeyByValue, isNull, isSuperuser, notNull} from "../../../utils/utils";
import {error_manager} from "../../../helper/error_manager";
import {FileType, Loader, MetsRiskFactor} from "../../../utils/const";
import {animateToState} from "../utils/map_utils";
import {LoadingText} from "../components/components";
import {get} from "../../../helper/request";
import {mapSlides} from "../utils/splitSyncUtils";
import FileScreenshotsList from "./FileScreenshotsList";
import CircularProgressWithLabel from "../components/CircularProgressWithLabel";
import {TimelineDot} from "@mui/lab";
import {store} from "../../../helper/store";
import {changeDisplayedSlide, resetDisplayedSlide} from "../../../redux_actions/maps.state.action";
import {updateMetsSelectedSlide} from "../../../redux_actions/cases.action";
import {get_file_read_status, set_file_read_status, updateSelectedFile} from "../../../redux_actions/files.action";
import {morphleBaseTheme1} from "../themes";
import {deleteFile} from "../utils/fileUtils";
import {updateDisplayedMap} from "../../../redux_actions/gamma.state.action";
import {notifyInfo} from "../utils/display.notification";
import {resetMetsRisk, updateMetsRisk} from "../utils/lnmets_utils";
import RefreshIcon from "@mui/icons-material/Refresh";

class Lnmets extends Component {

    constructor(props) {
        super(props);

        this.state = this.initState();
        this.ref = React.createRef();
        this.maxCharacters = this.props.maxCharacters || 6;
    }

    initState = () => {
        this.metsData = {"LOW": 0, "MEDIUM": 0, "HIGH": 0};
        this.metsToDisplay = null;
        this.props.slide?.case && this.fetchCase();
        return {};
    }

    fetchCase = () => get(`/api/case/${this.props.slide.case}/`)
        .then(case_ => {
            store.dispatch(get_file_read_status(case_.id, FileType.LNMET));
            this.filterCaseFilesForMets(case_);
        })
        .catch(error => error_manager("Failed to fetch case", error));

    changeSlideInMap = (slideId) => {
        store.dispatch(changeDisplayedSlide(this.state.case.slides.filter(slide => slide.id === slideId)[0]));
    }

    filterCaseFilesForMets = (case_) => {
        case_.files = case_.files.filter(file => file.type === FileType.LNMET);
        case_.files.map(file => {
            this.metsData[getKeyByValue(MetsRiskFactor, file.meta?.metsRisk || MetsRiskFactor.LOW)] += 1;
        });
        this.setState({case: case_});

        //Update the selected file if it is not in the list of files to display
        if (!this.metsToDisplay || this.metsToDisplay.length === 0) return;
        if (this.props.selected_file && this.metsToDisplay.find(file => this.props.selected_file === file.id)?.slide === this.props.__slide?.id) {
            return;
        }
        store.dispatch(updateSelectedFile(this.metsToDisplay[0].id));
    }

    updateMetsRisk = (newMetsRisk) => {
        const selectedFile = this.metsToDisplay.find(met => met.id === this.props.selected_file);
        if (isNull(selectedFile) || selectedFile.meta?.metsRisk === newMetsRisk) return;

        //Only call API if data needs to be changed actually
        updateMetsRisk(this.props.selected_file, newMetsRisk, this.props.activeMapId, this.props.slide.id).then(() => {
            this.state.case.files.forEach((file) => file.id === this.props.selected_file ? file.meta.metsRisk = newMetsRisk : null);
        });
    }

    keyFire = (event) => {
        switch (event.key) {
            case "ArrowUp":
                event.preventDefault();
                if (this.metsToDisplay) {
                    const currIndex = this.metsToDisplay.findIndex(f => f.id === this.props.selected_file);
                    if (currIndex === 0) return;
                    const newIndex = (currIndex - 1 + this.metsToDisplay.length) % this.metsToDisplay.length;
                    this.onScreenshotClick(this.metsToDisplay[newIndex])
                }
                break;
            case "ArrowDown":
                event.preventDefault();
                if (this.metsToDisplay) {
                    const currIndex2 = this.metsToDisplay.findIndex(f => f.id === this.props.selected_file);
                    if (currIndex2 === this.metsToDisplay.length - 1) return;
                    const newIndex2 = (currIndex2 + 1) % this.metsToDisplay.length;
                    this.onScreenshotClick(this.metsToDisplay[newIndex2])
                }
                break;
            case "n":
            case "N": {
                this.updateMetsRisk(MetsRiskFactor.LOW)
                break;
            }
            case "m":
            case "M": {
                this.updateMetsRisk(MetsRiskFactor.HIGH);
                break;
            }
            default:
                break;
        }
    }

    handleDeleteMetsFile = (metsFile) => deleteFile(metsFile).then(() => {
        const indexToRemove = this.metsToDisplay.findIndex(file => file.id === metsFile.id);
        this.metsToDisplay.splice(indexToRemove, 1);
        this.forceUpdate();
    });

    waitAndAnimateToLocation = () => {
        let initialFocus = setInterval(() => {
            if (document.getElementsByClassName("scrollIntoView").length > 0 && this.props.selected_file && this.metsToDisplay) {
                document.getElementsByClassName("scrollIntoView")[0].scrollIntoView({
                    behavior: "auto", block: "center", inline: "nearest"
                });
                this.onScreenshotClick(this.metsToDisplay.find(file => this.props.selected_file === file.id))
                clearInterval(initialFocus);
            }
        }, 500);
    }

    componentDidMount() {
        window.addEventListener("keyup", this.keyFire);
        store.dispatch(updateDisplayedMap(this.props.activeMapId));
        //Anything lower than 500ms will cause the scrollIntoView to interrupt the animation
        this.waitAndAnimateToLocation()
        notifyInfo('mets', "Press 'N' for high risk, 'M' for low risk, and 'Arrow Up' and 'Arrow Down' to navigate between images");
    }

    componentWillUnmount() {
        store.dispatch(resetDisplayedSlide());
        window.removeEventListener("keyup", this.keyFire);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // @Spandan - after multiple testing, block: "center" and inline: "nearest" are the only options
        // that do not abruptly interrupt the animation
        if (prevProps.selected_file !== this.props.selected_file || prevProps.metsSelectedSlide !== this.props.metsSelectedSlide) {
            if (document.getElementsByClassName("scrollIntoView").length > 0) {
                document.getElementsByClassName("scrollIntoView")[0].scrollIntoView({
                    behavior: "smooth", block: "center", inline: "nearest"
                });
            }
        }

        if (prevProps.slide !== this.props.slide) {
            this.setState(this.initState());
        }
    }

    updateProperties = () => {
        this.totalSlides = this.state.case.slides.length;
        this.metsToDisplay = this.getMetsToDisplay();
    }

    split = () => mapSlides([this.props.permanentSlide, ...this.state.case.slides.filter(slide => slide.checked && slide.id !== this.props.permanentSlide.id)]);

    getMetsColorCode = (riskFactor) => {
        switch (riskFactor) {
            case MetsRiskFactor.LOW:
                return "green";
            case MetsRiskFactor.MEDIUM:
                return "orange";
            case MetsRiskFactor.HIGH:
                return "red";
            default:
                return "green";
        }
    }

    getMediumRiskPercentage = () => {
        let total = this.metsData["LOW"] + this.metsData["MEDIUM"] + this.metsData["HIGH"];
        if (total <= 0) return 0;
        return 100 * this.metsData["MEDIUM"] / (total);
    }

    getDotStyle = (read, metsRisk) => read ? {mx: 0.5, backgroundColor: this.getMetsColorCode(metsRisk)} : {
        mx: 0.5,
        backgroundColor: this.getMetsColorCode(metsRisk),
        boxShadow: `0 0 0 2px ${morphleBaseTheme1.palette.background.paper}, 0 0 0 4px ${this.getMetsColorCode(metsRisk)}`
    }

    getSlicedSlideName = (slide_name) => slide_name.slice(0, this.maxCharacters) + (slide_name.length > this.maxCharacters ? '...' : '')

    getSelectedSlideNameComponent = () => <Stack direction={"row"} alignItems={"center"} justifyContent={"center"}>
        <Typography color={"whitesmoke"}>
            {`Slide - ${this.props.metsSelectedSlide === "" ? "ALL" : this.state.case.slides.find(slide => slide.id === this.props.metsSelectedSlide).name}  ( ${this.metsToDisplay.length} Regions )`}
        </Typography>
    </Stack>

    getMetsToDisplay = () => this.props.metsSelectedSlide !== "" ? this.state.case.files.filter(file => file.slide === this.props.metsSelectedSlide) : this.state.case.files;

    selectSlide = (slideId, allSlides) => {
        store.dispatch(updateMetsSelectedSlide(slideId));
        if (!allSlides) this.changeSlideInMap(slideId);
    }

    getHighRiskRatio(slideId) {
        let highRisks = 0;
        let totalRisks = 0;

        this.state.case.files.forEach((file) => {
            if (file.slide === slideId) {
                if (file.meta.metsRisk === 1) {
                    highRisks++;
                }
                totalRisks++;
            }
        })

        return <>{highRisks} / {totalRisks}</>
    }

    onScreenshotClick = (file) => {
        store.dispatch(set_file_read_status(file.id, true));
        store.dispatch(updateSelectedFile(file.id));
        if (file.slide !== this.props.mapsState[this.props.displayedMapId].slideId) {
            this.changeSlideInMap(file.slide)
            this.waitAndAnimateToLocation()
        } else {
            animateToState(this.props.__slidemap.getView(), file.meta.mapState)
        }
    }

    getScreenshotComponent = () => <FileScreenshotsList files={this.metsToDisplay}
                                                        type={FileType.LNMET}
                                                        cols={1}
                                                        itemBarPosition={"below"}
                                                        backgroundColor={'rgba(255, 255, 255, 0.9)'}
                                                        showOnHover={false}
                                                        selected={this.props.selected_file}
                                                        customAction={file => <TimelineDot sx={{
                                                            mx: 0.5,
                                                            backgroundColor: this.getMetsColorCode(file.meta?.metsRisk)
                                                        }}/>}
                                                        title={file => this.state.case.slides.map(slide => slide.id === file.slide &&
                                                            <Typography color={'black'}
                                                                        px={1}>{this.getSlicedSlideName(slide.name)}</Typography>)}
                                                        onClick={file => this.onScreenshotClick(file)}
                                                        onDelete={isSuperuser() ? this.handleDeleteMetsFile : null}
    />

    getSlideSpecificList = () => {
        // Sorting slides based on number of lymph nodes in descending order
        return this.state.case.slides.map((slide, index) => <Stack
            width={'100%'}>
            {index !== 0 ? <Divider sx={{my: 1}}/> : null}
            <Grid container width={'100%'}>
                <Grid item xs={3} style={{display: 'flex', alignItems: 'start', cursor: 'pointer'}}
                      onClick={() => this.selectSlide(slide.id, false)}>
                    <Typography
                        color={this.props.metsSelectedSlide === slide.id ? 'secondary' : 'text.primary'}
                        height={'35px'} style={{
                        display: 'flex', alignItems: 'center'
                    }}>{this.getSlicedSlideName(slide.name)}</Typography>
                </Grid>
                <Grid item xs={6}>
                    <Grid container width={'100%'}>
                        {this.state.case.files.filter(file => file.slide === slide.id).map(file => <Grid item xs={3}
                                                                                                         onClick={() => this.onScreenshotClick(file)}
                                                                                                         sx={{cursor: 'pointer'}}><Stack
                            flexDirection={"row"} alignItems={"center"} justifyContent={"center"}><TimelineDot
                            sx={this.getDotStyle(this.props.readLog[file.id] === true, file.meta?.metsRisk)}/></Stack></Grid>)}
                    </Grid>
                </Grid>
                <Grid item xs={3} style={{
                    display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-end', paddingTop: '4px'
                }}>
                    {this.getHighRiskRatio(slide.id)}
                </Grid>
            </Grid>
        </Stack>)
    }
    getSummaryComponent = () => {
        return <Grid container width={'100%'} height={'auto'} sx={{pr: '5px'}}>
            <Grid item xs={2} style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}
                  onClick={() => this.selectSlide("", true)}>
                <Typography
                    color={this.props.metsSelectedSlide === "" ? 'secondary' : 'text.primary'}>ALL</Typography>
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid item xs={4}>
                <Stack direction={'row'} alignItems={"center"} justifyContent={"center"}>
                    <CircularProgressWithLabel value={this.getMediumRiskPercentage()}
                                               customColor={'yellow'} customText={this.metsData["MEDIUM"]}/>
                </Stack>
            </Grid>
            <Grid item xs={2}>
                <Stack direction={'row'} alignItems={"center"} justifyContent={"center"}>
                    <Tooltip title={"Reset"} placement={"top-start"}>
                        <IconButton
                            onClick={() => resetMetsRisk(this.state.case.id, this.props.activeMapId, this.props.slide.id)}
                            sx={{color: 'red'}}><RefreshIcon/></IconButton>
                    </Tooltip>
                </Stack>
            </Grid>
            <Grid item xs={2} style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
                {this.metsData["HIGH"]}/{this.metsData["LOW"] + this.metsData["MEDIUM"] + this.metsData["HIGH"]}
            </Grid>
        </Grid>
    }

    render() {
        if (this.props.loadingState.loading) {
            return <Loader/>
        }
        if (!notNull(this.props.slide.case)) return <Typography>No case associated with this slide</Typography>;
        if (!this.state.case) return <LoadingText/>;
        this.updateProperties();
        return <Stack ref={this.ref} direction={"column"} spacing={1.5} height={"100%"}>
            <Stack direction={"column"} spacing={1.5} height={'70%'}>
                {this.getSelectedSlideNameComponent()}
                {this.getScreenshotComponent()}
            </Stack>
            <Stack direction={"column"} spacing={1.5} height={'30%'}>
                <Divider/>
                {this.getSummaryComponent()}
                <Divider/>
                <Grid container overflow={'auto'}>
                    {this.getSlideSpecificList(this.metsData)}
                </Grid>
            </Stack>
        </Stack>
    }

}

const mapStateToProps = (state) => {
    let loadingState = state.slideLoadingReducer
    let gammaState = state.gammaStateReducer;
    let {activeMapId, displayedMapId, sync} = gammaState;
    let mapsState = state.mapsStateReducer;
    let {slide, slidemap, displaySetting, x, y, z, r} = mapsState[activeMapId] ?? {};
    if (isNull(displayedMapId)) {
        displayedMapId = activeMapId;
    }
    let {slide: __slide, slidemap: __slidemap} = mapsState[displayedMapId];
    let {metsSelectedSlide} = state.caseStatusReducer;
    let permanentSlide = Object.values(mapsState)[0].slide;
    let totalMaps = Object.keys(mapsState).length;
    let {extension} = state.screenshotStateReducer;
    let {readLog, selected_file} = state.filesReducer;
    return {
        activeMapId,
        displayedMapId,
        slidemap,
        slide,
        permanentSlide,
        sync,
        totalMaps,
        extension,
        displaySetting,
        x,
        y,
        z,
        r,
        metsSelectedSlide,
        readLog,
        selected_file,
        mapsState,
        __slide,
        __slidemap,
        loadingState
    };
};

export default connect(mapStateToProps)(Lnmets);
